import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  CheckOutlined,
  MinusOutlined,
  PauseCircleOutlined,
  StopOutlined,
} from "@ant-design/icons";

export const textColor: Record<string, string> = {
  Active: "#283833",
  Complete: "#064C68",
  "Early Termination": "#73134A",
  "Not Enrolled": "#20353E",
  Administered: "#064C68",
  Increased: "#004A42",
  Reduced: "#BE4E01",
  Missed: "#73134A",
  Interrupted: "#3F3518",
  "Not Required": "#20353E",
  "Data Pending": "#3F3518",
  "Data Missing": "#A04000",
  "Data Discrepancy": "#980000",
};

export const borderColor: Record<string, string> = {
  Active: "#CAE6D6",
  Complete: "#D2EFF9",
  "Early Termination": "#EBD1E0",
  "Not Enrolled": "#D5DADC",
  Administered: "#D2EFF9",
  Increased: "#CAE6D6",
  Reduced: "#F2C9AE",
  Missed: "#EBD1E0",
  Interrupted: "#FEF7DF",
  "Not Required": "#D5DADC",
  "Data Pending": "#FEF7DF",
  "Data Missing": "#F2C9AE",
  "Data Discrepancy": "#F8CACA",
};

export const pillColor: Record<string, string> = {
  Active: "#CAE6D6",
  Complete: "#D2EFF9",
  "Early Termination": "#EBD1E0",
  "Not Enrolled": "#D5DADC",
  Administered: "#D2EFF9",
  Increased: "#CAE6D6",
  Reduced: "#F2C9AE",
  Missed: "#EBD1E0",
  Interrupted: "#FEF7DF",
  "Not Required": "#D5DADC",
  "Data Pending": "#FEF7DF",
  "Data Missing": "#F2C9AE",
  "Data Discrepancy": "#F8CACA",
};

export const tooltipTitle: Record<string, string> = {
  Active: "Subject is part of a study that is ongoing.",
  Complete: "Subject completed the study.",
  "Early Termination": "Subject discontinued study prior to completion.",
  "Not Enrolled":
    "Subject has not been randomized and is not enrolled in the study.",
  Administered: "Study intervention was administered as expected.",
  Increased: "Dose was increased.",
  Reduced: "Dose was reduced.",
  Missed: "Study intervention was not administered.",
  Interrupted: "Administration of study intervention was interrupted.",
  "Not Required":
    "Administration of study intervention was not required at the visit timepoint due to schedule or subject's study status.",
  "Data Pending": "Data not yet available.",
  "Data Missing": "Expected data not found.",
  "Data Discrepancy": "Data mismatch.",
};

export const iconTypeMap: Record<string, React.ReactElement> = {
  Administered: <CheckOutlined style={{ color: "#064C68" }} />,
  Increased: <ArrowUpOutlined style={{ color: "#004A42" }} />,
  Reduced: <ArrowDownOutlined style={{ color: "#BE4E01" }} />,
  Missed: <StopOutlined style={{ color: "#73134A" }} />,
  Interrupted: <PauseCircleOutlined style={{ color: "#3F3518" }} />,
  "Not Required": <MinusOutlined style={{ color: "#20353E" }} />,
};
